module.exports = __webpack_public_path__ + "static/media/frame-c-arrow-right.dc120ae0.svg";